module.exports = __webpack_public_path__ + "img/SketchPnga44b131e28d649fc0d36334b02c6f3ac976484ae5c9ddb871e2e98106a07fad7.324297d3.png";